import { render, staticRenderFns } from "./ListPindahBarang.vue?vue&type=template&id=cff5539a&"
import script from "./ListPindahBarang.vue?vue&type=script&lang=js&"
export * from "./ListPindahBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports